window.scrollRight = scrollRight;
document.addEventListener('DOMContentLoaded', () => {
    const navContainer = document.querySelector("#scroll-nav .js-tab-container");
    navContainer === null || navContainer === void 0 ? void 0 : navContainer.addEventListener("scroll", () => {
        updateButtonVisibility();
    });
});
export function scrollRight() {
    const scrollAmount = 200;
    const navContainer = document.querySelector("#scroll-nav .js-tab-container");
    navContainer.scrollBy({ left: scrollAmount, behavior: "smooth" });
}
function updateButtonVisibility() {
    const scrollButton = document.querySelector("#scroll-nav button");
    const navContainer = document.querySelector("#scroll-nav .js-tab-container");
    if (navContainer.scrollWidth - navContainer.clientWidth - navContainer.scrollLeft <= 10) {
        scrollButton.style.display = "none";
    }
    else {
        scrollButton.style.display = "block";
    }
}
export const scrollTabIntoView = (tab, containerSelector = '.js-tab-container') => {
    const container = document.querySelector(containerSelector);
    if (!container || !tab)
        return;
    const containerRect = container.getBoundingClientRect();
    const tabRect = tab.getBoundingClientRect();
    const offsetLeft = tabRect.left - containerRect.left;
    const scrollPosition = container.scrollLeft +
        offsetLeft -
        container.clientWidth / 2 +
        tab.clientWidth / 2;
    container.scrollTo({
        left: scrollPosition,
        behavior: 'smooth',
    });
};
